import { createEvent } from 'effector';
import { TStateStoreReducer } from '@src/molecules/DataTable/models';

type TReducer = TStateStoreReducer<void>;

export const setDefaultPagingEvent = createEvent();
export const setDefaultPagingEventReducer: TReducer = (state) => {
  return {
    ...state,
    paging: {
      offset: 0,
      limit: state.paging.limit,
    },
  };
};
